import React, { useContext } from "react"
import markdownit from "markdown-it"
import underline from "markdown-it-plugin-underline"

import { EditorContext } from "../../Contexts/EditorContext"
import { EditableText } from "../../templates/components/EdtitableText"

const Renderer = markdownit({
  breaks: true,
}).use(underline)

const ExternalLinkRenderer = markdownit({
  breaks: true,
}).use(underline)

const defaultLinkOpen =
  ExternalLinkRenderer.renderer.rules.link_open ||
  ((tokens, index, options, _env, self) =>
    self.renderToken(tokens, index, options))

ExternalLinkRenderer.renderer.rules.link_open = (
  tokens,
  index,
  options,
  env,
  self
) => {
  const href = tokens[index].attrGet("href")

  if (/^https?:\/\//i.test(href)) {
    tokens[index].attrSet("target", "_blank")
    tokens[index].attrSet("rel", "noopener noreferrer")
  }

  return defaultLinkOpen(tokens, index, options, env, self)
}

export const Text = ({ stateProps, htmlProps }) => {
  const pageState = stateProps.pageContext && stateProps.pageContext[0]
  const pageSlug =
    pageState &&
    pageState.page &&
    pageState.page.data &&
    pageState.page.data.slug &&
    pageState.page.data.slug.iv
  const renderer = /\/(resources|ressources)\//.test(pageSlug)
    ? ExternalLinkRenderer
    : Renderer

  return (
    <div {...htmlProps}>
      {stateProps.text && stateProps.text !== "undefined" ? (
        <div
          dangerouslySetInnerHTML={{ __html: renderer.render(stateProps.text) }}
        />
      ) : null}
    </div>
  )
}
Text.displayName = "Text"

export const TextCanvas = ({ stateProps, htmlProps }) => {
  const [state] = useContext(EditorContext)

  if (state.selected !== stateProps.id)
    return <Text stateProps={stateProps} htmlProps={htmlProps} />

  console.log("TEXT CANVAS", stateProps)

  return (
    <div {...htmlProps}>
      <EditableText
        id={stateProps.id}
        text={stateProps.text}
        rawText={stateProps.textRaw}
      />
    </div>
  )
}
TextCanvas.displayName = "TextCanvas"
